var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie"},[_c('v-charts',{staticStyle:{"width":"100%","height":"100%"},attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }